const LevelItem = ({ heading, value }) => (
    <div className="level-item has-text-centered">
        <div>
            <p className="heading">{heading}</p>
            <p className="title">{value}</p>
        </div>
    </div>
);

const Level = ({ children }) => (
    <nav className="level is-mobile">
        {children}
    </nav>
);

export { Level, LevelItem };
